/** Best-effort readable message from an API/network error. */
export const errMsg = (err, fallback = 'Something went wrong. Please try again.') =>
  err?.response?.data?.message ||
  err?.data?.message ||
  err?.message ||
  fallback;
